import PropTypes from "prop-types"
import React from "react"
import CountUp from "react-countup"
import Visibility from "../visibility"

import { Context } from "../../utility/context"

const MovementsForecasts = ({ blockMovement, blockForecast, animate }) => (
  <Context.Consumer>
    {context => (
      <Visibility>
        {({ isVisible }) => (
          <div className="col col-12 bg-mercer-glass-dark fg-mercer-gray-dark black p2 md-py2 md-px3 mb2 relative">
            <div className="col col-12 center">
              <h3 className="mt0 mb1 uppercase letter-space-1.5">REMUNERATION MOVEMENTS & FORECASTS [{context.selected.quarterly.edition}]</h3>
              <h4 className="mt0 mb2">How industries compare by median remuneration movements by industry.</h4>
              <div className="lg-flex">
                <div className="flex mb1 flex-1">
                  <div className="col-7 left-align pr1">
                    <div className="uppercase">{blockMovement.title}</div>
                    <h4 className="thin">{blockMovement.content}</h4>
                  </div>
                  <div className="col-5 large-digi px1">
                    <span className="fg-mercer-blue-mid mr1">
                      <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="38px" height="38px">
                        <path fill="currentColor" d="M347.404 142.86c-4.753 4.753-4.675 12.484.173 17.14l73.203 70H91.22l73.203-70c4.849-4.656 4.927-12.387.173-17.14l-19.626-19.626c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L128 388.766c4.686 4.686 12.284 4.686 16.971 0l19.626-19.626c4.753-4.753 4.675-12.484-.173-17.14L91.22 282h329.56l-73.203 70c-4.849 4.656-4.927 12.387-.173 17.14l19.626 19.626c4.686 4.686 12.284 4.686 16.971 0l124.485-124.281c4.686-4.686 4.686-12.284 0-16.971L384 123.234c-4.686-4.686-12.284-4.686-16.971 0l-19.625 19.626z"></path>
                      </svg>
                    </span>
                    <span className='fg-mercer-blue-dark' ><CountUp duration={2.5} useEasing={true} end={animate && isVisible ? parseFloat(blockMovement.percentage) : 0} decimals={parseFloat(blockMovement.percentage).toFixed(2).split(".")[1][1] === "0" ? 1 : 2} />%</span>
                  </div>
                </div>
                <div className="flex mb1 flex-1">
                  <div className="col-7 left-align pl3">
                    <div className="uppercase">{blockForecast.title}</div>
                      <h4 className="thin">{blockForecast.content}</h4>
                    </div>
                  <div className="col-5 large-digi px1">
                    <span className="fg-mercer-blue-mid mr1">
                      <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="38px" height="38px">
                        <path fill="currentColor" d="M273.1 347.4c-4.8-4.8-12.5-4.7-17.1.2l-70 73.2V91.2l70 73.2c4.7 4.8 12.4 4.9 17.1.2l19.6-19.6c4.7-4.7 4.7-12.3 0-17L168.5 3.5c-4.7-4.7-12.3-4.7-17 0L27.2 128c-4.7 4.7-4.7 12.3 0 17l19.6 19.6c4.8 4.8 12.5 4.7 17.1-.2l70-73.2v329.6l-70-73.2c-4.7-4.8-12.4-4.9-17.1-.2L27.2 367c-4.7 4.7-4.7 12.3 0 17l124.3 124.5c4.7 4.7 12.3 4.7 17 0L292.8 384c4.7-4.7 4.7-12.3 0-17l-19.7-19.6z"></path>
                      </svg>
                    </span>
                    <span className='fg-mercer-blue-dark' ><CountUp duration={2.5} useEasing={true} end={animate && isVisible ? parseFloat(blockForecast.percentage) : 0} decimals={parseFloat(blockForecast.percentage).toFixed(2).split(".")[1][1] === "0" ? 1 : 2} />%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col col-12 center">
              <a href="https://www.mercer.com.au/our-thinking/insights/remuneration-trends-and-insights/quarterly-remuneration-trends.html" target="_parent" className="btn btn-primary bg-mercer-gray-light fg-mercer-gray-dark">Learn More ></a>
            </div>
          </div>
        )}
      </Visibility>
    )}
  </Context.Consumer>
)

MovementsForecasts.propTypes = {
  blockMovement: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
    link1: PropTypes.string,
  }),
  animate: PropTypes.bool,
}

MovementsForecasts.defaultProps = {
  blockMovement: {
    title: ``,
    content: ``,
    link1: ``,
  },
  animate: true,
}

export default MovementsForecasts
